import React, { useEffect, useRef, useState } from 'react';
import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Container,
    Grid,
    Card,
    CardMedia,
    IconButton,
    Typography,
    Box,
} from "@mui/material";
import { useMediaQueries } from '../../usecontext/UseProvider';
import EastIcon from '@mui/icons-material/East';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PaginationSection from '../paginationsection/PaginationSection';
import { useNavigate, useParams } from 'react-router-dom';
import { getOurCategories, getOurCategoriesItems, getOurCategoriesItemsByID } from '../../services/OurCategories';

const ProductsList = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen, wpNumber } = useMediaQueries();
    const navigate = useNavigate();
    const [ourCategoriesData, setOurCategoriesData] = useState([])
    const [categoryProducts, setCategoryProducts] = useState([]);
    const [limit, setLimit] = useState(9);
    const [total, setTotal] = useState('');
    const [skip, setSkip] = useState(0);
    const { id } = useParams();
    const [categoryID, setCategoryID] = useState(id || '');
    const productListRef = useRef(null);

    useEffect(() => {
        if (!id) {
            setCategoryID('')
        }
    }, [id])

    const getOurCategoriesData = async () => {
        try {
            const response = await getOurCategories();
            setOurCategoriesData(response?.categoryData);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategoryProducts = async () => {
        try {
            const response = await getOurCategoriesItemsByID(categoryID, { skip: skip, limit: limit });
            setCategoryProducts(response?.categoryItems);
            setTotal(response?.total)
        } catch (error) {
            console.error("Error fetching category products:", error);
        }
    };

    const fetchAllProducts = async () => {
        try {
            const response = await getOurCategoriesItems({ skip: skip, limit: limit });
            setCategoryProducts(response?.categoryItemData);
            setTotal(response?.total)
        } catch (error) {
            console.error("Error fetching category products:", error);
        }
    };

    useEffect(() => {
        if (categoryID !== '') {
            fetchCategoryProducts()
        } else {
            fetchAllProducts()
        }
    }, [categoryID, skip])

    useEffect(() => {
        getOurCategoriesData();
    }, []);

    const handleCategoryChange = (event) => {
        setCategoryID(event.target.value);
        setSkip(0); // Reset skip to 0 when category changes
    };


    const handlePageChange = (event, value) => {
        const newSkip = (value - 1) * limit;
        setSkip(newSkip);
    };

    const sendWhatsAppMessage = (item) => {
        const baseUrl = window.location.origin; // Get the current base URL
        const itemUrl = `${baseUrl}/product-detail/${item?._id}`; // Construct the product detail URL dynamically
        const message = `Hello, I want to purchase:\n\n*${item?.name}*\n*URL:* ${itemUrl}\n\nThank you!`;
        const url = `https://wa.me/${wpNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    useEffect(() => {
        if (productListRef.current) {
            productListRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [skip]); // Ensure it runs when the page changes    

    return (
        <>
            <Container ref={productListRef} sx={{ py: { md: "5rem", xs: "2rem" }, }}>
                <Grid
                    container
                    rowSpacing={isSmallScreen ? 2 : 0}
                    columnSpacing={isSmallScreen ? 2 : 3}
                >
                    <Grid item md={3} xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend" sx={{ fontWeight: "bold", fontSize: "1.5rem", color: "black", mb: 2 }}>
                                Categories
                            </FormLabel>
                            <RadioGroup
                                value={categoryID}
                                onChange={handleCategoryChange}
                                aria-label="categories"
                            >
                                {ourCategoriesData?.length > 0 ? ourCategoriesData?.map((category, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={category?._id}
                                        control={
                                            <Radio
                                                sx={{
                                                    color: "#01A0E2", // default color
                                                    '&.Mui-checked': {
                                                        color: "#01A0E2", // checked color
                                                    },
                                                }}
                                            />
                                        }
                                        label={category?.name}
                                        sx={{
                                            color: "black",
                                            "& .MuiRadio-root": {
                                                color: "#01A0E2",
                                            },
                                        }}
                                    />
                                )) : 'No Data Found'}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item md={9} xs={12}>
                        <Grid container rowSpacing={isSmallScreen ? 4 : 6} columnSpacing={3}>
                            {categoryProducts?.length > 0 ?
                                categoryProducts?.map((item, index) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={4}
                                        key={index}
                                        data-aos="zoom-in"
                                        data-aos-delay={`${index * 100}`}
                                        sx={{ minHeight: '330px' }}
                                    >
                                        <Card
                                            sx={{
                                                height: '100%',
                                                borderRadius: '0',
                                                position: 'relative',
                                                overflow: 'visible',
                                                boxShadow: 'none',
                                                '&:hover .title': {
                                                    backgroundColor: '#01A0E2',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                image={item?.images[0]?.url}
                                                alt={item?.images?.url}
                                                sx={{ borderRadius: '0', height: '100%' }}
                                            />
                                            <Box
                                                className="title"
                                                sx={{
                                                    position: 'absolute',
                                                    left: '0px',
                                                    bottom: '35px',
                                                    zIndex: 11,
                                                    backgroundColor: 'white',
                                                    width: { sm: '90%', xs: '75%' },
                                                    py: 0.5,
                                                    clipPath: 'polygon(0 0, 100% 0%, 90% 100%, 0% 100%)',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                <Typography className="title" variant="body1" sx={{ textAlign: 'left', ml: 2, fontSize: isSmallScreen ? '16px' : '18px' }}>
                                                    {item?.name}
                                                </Typography>
                                            </Box>
                                            <Box
                                                onClick={() => sendWhatsAppMessage(item)}
                                                sx={{
                                                    position: 'absolute',
                                                    right: '0',
                                                    bottom: '-15px',
                                                    zIndex: 1111,
                                                    backgroundColor: '#25D366',
                                                    width: { sm: '85%', xs: '75%' },
                                                    border: '1px solid white',
                                                    color: '#fff',
                                                    py: 0.5,
                                                    clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 10% 100%)',
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <WhatsAppIcon />
                                                <Typography variant="body1" sx={{ textAlign: 'right', mr: 2, fontSize: isSmallScreen ? "16px" : "18px", color: '#fff' }}>
                                                    Buy Via WhatsApp
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    right: '1px',
                                                    bottom: '-15px',
                                                    zIndex: 111,
                                                    backgroundColor: '#fff',
                                                    width: { sm: '85%', xs: '75%' },
                                                    border: '1px solid white',
                                                    color: '#fff',
                                                    py: 0.5,
                                                    clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 10% 100%)',
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <WhatsAppIcon />
                                                <Typography variant="body1" sx={{ textAlign: 'right', mr: 2, fontSize: isSmallScreen ? "16px" : "18px", color: '#fff' }}>
                                                    Buy Via WhatsApp
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    opacity: 0,
                                                    transition: 'opacity 0.3s ease-in-out',
                                                    background: '#0A23574D',
                                                    '&:hover': {
                                                        opacity: 1,
                                                    },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -0%)',
                                                        top: '40%',
                                                        textAlign: 'center',
                                                        color: '#0A2357',
                                                        width: 'inherit',
                                                    }}
                                                >
                                                    <IconButton
                                                        onClick={() => navigate(`/product-detail/${item?._id}`)}
                                                        sx={{
                                                            p: 1.5,
                                                            backgroundColor: '#01A0E2',
                                                            color: '#fff',
                                                            '&:hover': { backgroundColor: '#01A0E2' },
                                                        }}
                                                    >
                                                        <EastIcon />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </Card>
                                    </Grid>
                                ))
                                :
                                <Grid item xs={12} >
                                    <Typography variant='h6'>No Data Found</Typography>
                                </Grid>}
                        </Grid>
                        <Box sx={{ mt: { lg: 10, xs: 5 } }}>
                            {total > 0 &&
                                <PaginationSection
                                    page={Math.floor(skip / limit) + 1} // Calculate current page
                                    onPageChange={handlePageChange}
                                    total={total}
                                    limit={limit}
                                />}
                        </Box>
                    </Grid>
                </Grid>

            </Container >
        </>
    );
};

export default ProductsList;